<ng-container *ngIf="guarantee">
	<div class="guarantee-details-block">
		<div class="guarantee-details-block-item">
			<div #customerInformation>
				<div class="guarantee-details-block-subtitle" translate>guarantee.customer.information</div>
				<div class="guarantee-details-block-info-grid2">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.customer.name</div>
						<div class="guarantee-details-block-value">{{
							(soldToName | uppercase) }}</div>
					</div>
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>batch-card.document-type</div>
						<div class="guarantee-details-block-value">{{getLongType(guarantee.applicationType)}}</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
					guarantee.project.type
				</div>
				<ng-container *ngIf="guarantee.applicationType === 'Magnelis-Solar'">
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.type.of.installation</div>
							<div class="guarantee-details-block-value" *ngIf="guarantee.installationType">
								{{ guarantee.installationType === 'Ground mounted / utility scale solar plant'
									? ('guarantee.ground.mounted' | translate | uppercase)
									: guarantee.installationType === 'Rooftop installation'
										? ('guarantee.rooftop.installation' | translate | uppercase)
										: guarantee.installationType === 'Floating Solar Installation'
											? ('guarantee.floating.solar.installation' | translate | uppercase)
											: (guarantee.installationType | uppercase)
								}}
							</div>
							<div class="guarantee-details-block-value" *ngIf="!guarantee.installationType">{{ UNDERSCORE }}</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.planned.operations</div>
							<div class="guarantee-details-block-value">{{ guarantee.newSolarplantCompleteConstruction === true ?
								('guarantee.new.solar.plant' | translate | uppercase): '' }}
							</div>
							<div class="guarantee-details-block-value">{{ guarantee.extensionExistingSolarplant === true ?
								('guarantee.extension.solar.plant' | translate | uppercase): '' }}
							</div>
							<div class="guarantee-details-block-value">{{ guarantee.retrofitting === true ?
								('guarantee.retrofitting.solar.plant' | translate | uppercase): '' }}
							</div>
							<div class="guarantee-details-block-value" *ngIf="guarantee.newSolarplantCompleteConstruction === false 
								&& guarantee.extensionExistingSolarplant === false 
								&& guarantee.retrofitting === false">{{ UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
						guarantee.project.size
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.power.generation</div>
							<div class="guarantee-details-block-value">{{ guarantee.dataOnTheProjectSize ?
								(guarantee.dataOnTheProjectSize | uppercase) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.tonnage.magnelis</div>
							<div class="guarantee-details-block-value">{{ guarantee.magnelisTonnage ?
								(guarantee.magnelisTonnage | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
						guarantee.mounting.system.producer
					</div>
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.msp.company.name</div>
							<div class="guarantee-details-block-value">{{ guarantee.mspCompanyName ?
								(guarantee.mspCompanyName | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
						guarantee.epc
					</div>
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.epc.company.name</div>
							<div class="guarantee-details-block-value">{{ guarantee.epcCompanyName ?
								(guarantee.epcCompanyName | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf=" guarantee.applicationType === 'Magnelis-Other application'">
					<div class="guarantee-details-block-info-grid1" translate>
						guarantee.project.size
					</div>
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.tonnage.magnelis</div>
							<div class="guarantee-details-block-value">{{guarantee.dataOnTheProjectSize ?
								(guarantee.dataOnTheProjectSize | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>guarantee.type.application</div>
					<ng-container *ngIf="guarantee.toaSilo === true">
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.silo</div>
								<div class="guarantee-details-block-value">{{(guarantee.siloBase === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.silo.products</div>
								<div class="guarantee-details-block-value">{{guarantee.siloProductsStored ?
									(guarantee.siloProductsStored | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.silo.liner</div>
								<div class="guarantee-details-block-value">{{(guarantee.linerInSilo ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.silo.parts</div>
								<div class="guarantee-details-block-value">{{guarantee.siloRoof === true ?
									('guarantee.silo.roof' |
									translate) : '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.siloCylinder === true ?
									('guarantee.silo.cylinder' |
									translate) : ''}}</div>
								<div class="guarantee-details-block-value">{{guarantee.siloInContactSoilConcrete === true ?
									('guarantee.silo.soil'
									| translate) : '' }}</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.siloRoof === false 
							&& guarantee.siloCylinder === false && guarantee.siloInContactSoilConcrete === false">{{ UNDERSCORE }}</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="guarantee.toaRoadResSystem === true">
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.road.restraint</div>
								<div class="guarantee-details-block-value">{{(guarantee.toaRoadResSystem === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.horizontal.rails</div>
								<div class="guarantee-details-block-value">{{(guarantee.rrsHorizontal === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
						</div>
		
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.rrs.welded</div>
								<div class="guarantee-details-block-value">{{(guarantee.rrsMagnelisWelded === true?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.rrs.poles</div>
								<div class="guarantee-details-block-value">{{(guarantee.rrsPoles === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.rrs.miscellaneous</div>
								<div class="guarantee-details-block-value">{{(guarantee.rrsMiscellaneous === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="guarantee.toaAcousticBarrier === true">
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.acoustic</div>
								<div class="guarantee-details-block-value">{{(guarantee.toaAcousticBarrier === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.acoustic.railroad</div>
								<div class="guarantee-details-block-value">{{(guarantee.acoRailroad === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.acoustic.road.traffic</div>
								<div class="guarantee-details-block-value">{{(guarantee.acoRoadTraffic === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.acoustic.concrete</div>
								<div class="guarantee-details-block-value">{{(guarantee.acoConcreteBase ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="guarantee.toaPerforatedSheet === true">
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.perforated.sheet</div>
								<div class="guarantee-details-block-value">{{(guarantee.peforatedSheet ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
		
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.per.rich</div>
								<div class="guarantee-details-block-value">{{guarantee.perPerRich ?
									(guarantee.perPerRich | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.per.app</div>
								<div class="guarantee-details-block-value">{{guarantee.perApp ?
									(guarantee.perApp | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>
					<div class="guarantee-details-block-info-grid2" *ngIf="guarantee.isTOAOtherApps === true">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.other</div>
							<div class="guarantee-details-block-value">{{(guarantee.isTOAOtherApps === true ?
								'guarantee.radio.yes':'guarantee.radio.no') | translate }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.other.application</div>
							<div class="guarantee-details-block-value">{{guarantee.toaOtherApplication ?
								(guarantee.toaOtherApplication | uppercase): UNDERSCORE }}
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf=" guarantee.applicationType === 'Magnelis-Building'">
					<div class="guarantee-details-block-info-grid1">
		
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.planned.operations</div>
							<div class="guarantee-details-block-value">{{guarantee.newBuildingCompleteConstruction === true
								?
								('guarantee.construction.new.building' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.extensionExistingBuilding === true ?
								('guarantee.extension.existing.building' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.retrofittingRepairExistingBuilding ===
								true ?
								('guarantee.retrofitting.existing.building' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value" *ngIf="guarantee.newBuildingCompleteConstruction === false 
								&& guarantee.extensionExistingBuilding === false 
								&& guarantee.retrofittingRepairExistingBuilding === false">{{ UNDERSCORE }}</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
						guarantee.project.size
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.tonnage.magnelis</div>
							<div class="guarantee-details-block-value">{{guarantee.magnelisTonnage ?
								(guarantee.magnelisTonnage | uppercase) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.surface.building</div>
							<div class="guarantee-details-block-value">{{guarantee.dataOnTheProjectSize ?
								(guarantee.dataOnTheProjectSize | uppercase) : UNDERSCORE }}
							</div>
						</div>
		
					</div>
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>guarantee.type.application</div>
					<div class="guarantee-details-block-info-grid1">
		
						<div class="guarantee-details-block-info-item">
		
							<div class="guarantee-details-block-value">{{guarantee.roofing === true ?
								('guarantee.roofing' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.wallFacade === true ?
								('guarantee.wall.facade' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.compositeFloor === true ?
								('guarantee.composite.floor' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.perforatedroofSheet === true ?
								('guarantee.perforated.sheet' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.perSheetRich ?
								(guarantee.perSheetRich | uppercase ): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.coldFormedStrut === true ?
								('guarantee.cold.structure' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.rainWaterSystemsGutters === true ?
								('guarantee.rainwater.systems' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value" *ngIf="guarantee.roofing === false 
								&& guarantee.wallFacade === false 
								&& guarantee.compositeFloor === false && guarantee.perforatedroofSheet === false
								&& guarantee.coldFormedStrut === false && 
								guarantee.rainWaterSystemsGutters === false">{{ UNDERSCORE }}</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.allocation.building</div>
							<div class="guarantee-details-block-value">{{guarantee.residentialUse === true ?
								('guarantee.residential' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.industrial === true ?
								('guarantee.industrial' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.agricultural === true ?
								('guarantee.agricultural' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.otherADB === true ?
								('guarantee.other.building' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.otherADBSpecify ?
								(guarantee.otherADBSpecify | uppercase ): '' }}</div>
		
							<div class="guarantee-details-block-value" *ngIf="guarantee.residentialUse === false 
								&& guarantee.industrial === false 
								&& guarantee.agricultural === false && guarantee.otherADB === false
								">{{ UNDERSCORE }}</div>
						</div>
		
					</div>
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-info-item" translate>
						guarantee.questions
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.inside-building.activity</div>
							<div class="guarantee-details-block-value">{{guarantee.acitivityInsideBuilding ?
								(guarantee.acitivityInsideBuilding | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
		
		
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.storage.chemicals</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.presenceofChemical === 'true' ? ('guarantee.radio.yes'  | translate) :
								guarantee.presenceofChemical === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.nature.content</div>
							<div class="guarantee-details-block-value">{{guarantee.natureContent ?
								(guarantee.natureContent | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.storage.fermentation</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.presenceofFermentation === 'true' ? ('guarantee.radio.yes' | translate) :
								guarantee.presenceofFermentation === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE  }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.nature.content</div>
							<div class="guarantee-details-block-value">{{guarantee.natureContent2 ?
								(guarantee.natureContent2 | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1">
		
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.presence.animals</div>
							<div class="guarantee-details-block-value">{{guarantee.cattle === true ?
								('guarantee.cattle' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.pigs === true ?
								('guarantee.pigs' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.polutry === true ?
								('guarantee.Poultry' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.otherAnimals === true ?
								('guarantee.others.animals' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.animalsInsideBuilding ?
								(guarantee.animalsInsideBuilding | uppercase) : '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.densityofAnimals ?
								(guarantee.densityofAnimals | uppercase) : '' }}</div>
							<div class="guarantee-details-block-value" *ngIf="guarantee.cattle === false 
								&& guarantee.pigs === false 
								&& guarantee.polutry === false && guarantee.otherAnimals === false">{{ UNDERSCORE }}</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1">
		
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.manure.management</div>
							<div class="guarantee-details-block-value">{{guarantee.manureManagementGrantings === true ?
								('guarantee.gratings' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.manureManagementWOGrantings === true ?
								('guarantee.without.gratings' | translate | uppercase): '' }}</div>
		
							<div class="guarantee-details-block-value" *ngIf="guarantee.manureManagementGrantings === false 
								&& guarantee.manureManagementWOGrantings === false 
								">{{ UNDERSCORE }}</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.gas.building</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.gasVapour === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.gasVapour === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.nature.content</div>
							<div class="guarantee-details-block-value">{{guarantee.gasvaporNatureContent ?
								(guarantee.gasvaporNatureContent | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.building.heated</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.buildingHeated === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.buildingHeated === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.heating.type</div>
							<div class="guarantee-details-block-value">{{guarantee.heatingType ?
								(guarantee.heatingType | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1">
		
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.equipment</div>
							<div class="guarantee-details-block-value">{{guarantee.qiaExtractor === true ?
								('guarantee.extractor' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.qiaChimney === true ?
								('guarantee.chimney' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.qiaNaturalventilation === true ?
								('guarantee.natural.ventilation' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.qiaForcedventilation === true ?
								('guarantee.forced.ventilation' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.otherEquipment === true ?
								('claim.sample.other' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.specifyOtherEquipment ?
								(guarantee.specifyOtherEquipment | uppercase ): '' }}</div>
		
							<div class="guarantee-details-block-value" *ngIf="guarantee.qiaExtractor === false 
								&& guarantee.qiaChimney === false && guarantee.qiaNaturalventilation === false 
								&& guarantee.qiaForcedventilation === false && guarantee.otherEquipment === false 
								">{{ UNDERSCORE }}</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.condensation.rink</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.qiacondriskbuilding === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.qiacondriskbuilding === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.relative.humidity</div>
							<div class="guarantee-details-block-value">{{guarantee.humiditySpec ?
								(guarantee.humiditySpec | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="guarantee.applicationType === 'Organic Coating'">
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.planned.operations</div>
							<div class="guarantee-details-block-value">{{ guarantee.newBuildingCompleteConstruction === true ?
								('guarantee.construction.new.building' | translate | uppercase): '' }}
							</div>
							<div class="guarantee-details-block-value">{{ guarantee.extensionExistingBuilding === true ?
								('guarantee.extension.existing.building' | translate | uppercase): '' }}
							</div>
							<div class="guarantee-details-block-value">{{ guarantee.retrofittingRepairExistingBuilding === true ?
								('guarantee.retrofitting.existing.building' | translate | uppercase): '' }}
							</div>
							<div class="guarantee-details-block-value"
								*ngIf="guarantee.newBuildingCompleteConstruction === false && guarantee.extensionExistingBuilding === false
								&& guarantee.retrofittingRepairExistingBuilding === false">{{ UNDERSCORE }}</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.reason</div>
							<div class="guarantee-details-block-value">{{guarantee.reason ?
								(guarantee.reason | uppercase) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.nature.material</div>
							<div class="guarantee-details-block-value">{{guarantee.natureMaterial ?
								(guarantee.natureMaterial | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.condition.material</div>
							<div class="guarantee-details-block-value">{{guarantee.conditionMaterial ?
								(guarantee.conditionMaterial | uppercase) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.age.material</div>
							<div class="guarantee-details-block-value">{{guarantee.ageMaterial ?
								(guarantee.ageMaterial | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.allocation.building</div>
							<div class="guarantee-details-block-value">{{guarantee.residentialUse === true ?
								('guarantee.residential' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.industrial === true ?
								('guarantee.industrial' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.agricultural === true ?
								('guarantee.agricultural' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.otherADB === true ?
								('guarantee.other.building' | translate | uppercase): '' }}</div>
							<div class="guarantee-details-block-value">{{guarantee.otherADBSpecify ?
								(guarantee.otherADBSpecify | uppercase ): '' }}</div>
							<div class="guarantee-details-block-value"
								*ngIf="guarantee.residentialUse === false && guarantee.industrial === false
								&& guarantee.agricultural === false && guarantee.otherADB === false">
								{{ UNDERSCORE }}</div>
						</div>
					</div>
					<ng-container *ngIf="guarantee.industrialBuilding === true">
						<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
							guarantee.industrial.questions
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.inside-building.activity</div>
								<div class="guarantee-details-block-value">{{guarantee.acitivityInsideBuilding ?
									(guarantee.acitivityInsideBuilding | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.storage.chemicals</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.presenceofChemical === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.presenceofChemical === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.nature.content</div>
								<div class="guarantee-details-block-value">{{guarantee.natureContent ?
									(guarantee.natureContent | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.storage.fermentation</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.presenceofFermentation === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.presenceofFermentation === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.nature.content</div>
								<div class="guarantee-details-block-value">{{guarantee.natureContent2 ?
									(guarantee.natureContent2 | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.gas.building</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.gasVapour === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.gasVapour === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.nature.content</div>
								<div class="guarantee-details-block-value">{{guarantee.gasvaporNatureContent ?
									(guarantee.gasvaporNatureContent | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.building.heated</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.buildingHeated === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.buildingHeated === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.heating.type</div>
								<div class="guarantee-details-block-value">{{guarantee.heatingType ?
									(guarantee.heatingType | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.equipment</div>
								<div class="guarantee-details-block-value">{{guarantee.qiaExtractor === true ?
									('guarantee.extractor' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.qiaChimney === true ?
									('guarantee.chimney' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.qiaNaturalventilation === true ?
									('guarantee.natural.ventilation' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.qiaForcedventilation === true ?
									('guarantee.forced.ventilation' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.otherEquipment === true ?
									('claim.sample.other' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.specifyOtherEquipment ?
									(guarantee.specifyOtherEquipment | uppercase ): '' }}</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.qiaExtractor === false 
									&& guarantee.qiaChimney === false && guarantee.qiaNaturalventilation === false 
									&& guarantee.qiaForcedventilation === false && guarantee.otherEquipment === false 
									">{{ UNDERSCORE }}</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.humidity.rate.inside.building</div>
								<div class="guarantee-details-block-value">{{guarantee.buildingHumidityRate ?
									(guarantee.buildingHumidityRate | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.condensation.rink</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.qiacondriskbuilding === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.qiacondriskbuilding === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="guarantee.agriculturalBuilding === true">
						<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
							guarantee.agricultural.questions
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.activity.building</div>
								<div class="guarantee-details-block-value">{{guarantee.storageFodder === true ?
									('guarantee.fodder' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.storageFertilizer === true ?
									('guarantee.fertilizer' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.breedingAnimals === true ?
									('guarantee.breeding.animals' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.storageFodder === false 
									&& guarantee.storageFertilizer === false && guarantee.storageFertilizer === false 
									&& guarantee.breedingAnimals === false">{{ UNDERSCORE }}</div>
							</div>
							<div class="guarantee-details-block-info-item" *ngIf="guarantee.breedingAnimals === true">
								<div class="guarantee-details-block-label" translate>guarantee.breeding.animals</div>
								<div class="guarantee-details-block-value">{{guarantee.cattle === true ?
									('guarantee.cattle' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.pigs === true ?
									('guarantee.pigs' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.polutry === true ?
									('guarantee.Poultry' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">
									{{(guarantee.otherAnimals === true && guarantee.animalsInsideBuilding) ?
									(guarantee.animalsInsideBuilding | uppercase): '' }}</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.cattle === false 
									&& guarantee.pigs === false && guarantee.polutry === false 
									&& guarantee.otherAnimals === false">{{ UNDERSCORE }}</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.animals.shed</div>
								<div class="guarantee-details-block-value">{{guarantee.animalsinShed ?
									(guarantee.animalsinShed | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.animals.density</div>
								<div class="guarantee-details-block-value">{{guarantee.densityofAnimals ?
									(guarantee.densityofAnimals | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.manure.management</div>
								<div class="guarantee-details-block-value">{{guarantee.concreteGratingDuckboard === true ?
									('guarantee.duckboard' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.noDuckboard === true ?
									('guarantee.no.duckboard' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.concreteGratingDuckboard === false 
									&& guarantee.noDuckboard === false">{{ UNDERSCORE }}</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.ambiance</div>
								<div class="guarantee-details-block-label" translate>guarantee.equipment</div>
								<div class="guarantee-details-block-value">{{guarantee.naturalVentilationWall === true ?
									('guarantee.ventilation.walls' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.naturalVentilationRoof === true ?
									('guarantee.ventilation.roof' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.forcedVentilation === true ?
									('guarantee.forced.ventilation' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.otherVentilation === true ?
									('guarantee.others.animals' | translate | uppercase): '' }}</div>
								<div class="guarantee-details-block-value">{{guarantee.otherVentilationSpecify ?
									(guarantee.otherVentilationSpecify | uppercase): '' }}</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.naturalVentilationWall === false 
									&& guarantee.naturalVentilationRoof === false && guarantee.forcedVentilation === false 
									&& guarantee.otherVentilation === false">{{ UNDERSCORE }}</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.air.renewal</div>
								<div class="guarantee-details-block-value">{{guarantee.airRenewal ?
									(guarantee.airRenewal | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.ammonia</div>
								<div class="guarantee-details-block-value">{{guarantee.ammonia ?
									(guarantee.ammonia | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.hydrogen.sulphide</div>
								<div class="guarantee-details-block-value">{{guarantee.hydrogenSulphide ?
									(guarantee.hydrogenSulphide | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.humidity.rate.inside.building</div>
								<div class="guarantee-details-block-value">{{guarantee.buildingHumidityRate ?
									(guarantee.buildingHumidityRate | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.humidity.specify</div>
								<div class="guarantee-details-block-value">{{guarantee.humidity ?
									(guarantee.humidity | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.condensation.rink</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.qiacondriskbuilding === 'true' ? ('guarantee.radio.yes' | translate) :
									guarantee.qiacondriskbuilding === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>
				</ng-container>
			</div>
			<div #constructionSite>
				<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
					guarantee.construction.site
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.project.name</div>
						<div class="guarantee-details-block-value">{{guarantee.name ? (guarantee.name | uppercase) : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1" *ngIf="guarantee.address">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.address</div>
						<div class="guarantee-details-block-value">{{guarantee.address | uppercase}}</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid2">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.latitude</div>
						<div class="guarantee-details-block-value">{{guarantee.latitude ?(guarantee.latitude | uppercase) : UNDERSCORE }}</div>
					</div>
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.longitude</div>
						<div class="guarantee-details-block-value">{{guarantee.longitude ?
							(guarantee.longitude | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
				<ng-container *ngIf="guarantee.applicationType === 'Organic Coating'">
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
						guarantee.building.altitude</div>
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.altitude.above.900m</div>
							<div class="guarantee-details-block-value">{{(guarantee.buildingEnvAltitude === true ?
								'guarantee.radio.yes':'guarantee.radio.no') | translate }}</div>
						</div>
					</div>
				</ng-container>
			</div>
			<div #projectLocation>
				<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
					guarantee.project.location
				</div>
				<div class="guarantee-details-block-info-grid1" *ngIf="guarantee.applicationType !== 'Organic Coating'">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.rural.area</div>
						<div class="guarantee-details-block-value">{{(guarantee.ruralAreaDistantFromCoast === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1" *ngIf="guarantee.applicationType === 'Organic Coating'">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.rural.area.20KM</div>
						<div class="guarantee-details-block-value">{{(guarantee.buildingEnvBLMoreThan20KMFromCoast === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.proximity.buildings</div>
						<div class="guarantee-details-block-value">{{(guarantee.proximityBuildingAnimals === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.distance.site</div>
						<div class="guarantee-details-block-value">{{guarantee.animalDistance ?
							(guarantee.animalDistance | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.urban.agglomeration</div>
						<div class="guarantee-details-block-value">{{ (guarantee.urbanOrIndustrialArea === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.refineries.factories</div>
						<div class="guarantee-details-block-value">{{ (guarantee.mainlyComprisingRefinerie === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.distance.site</div>
						<div class="guarantee-details-block-value">{{ guarantee.hazardousIndustryDistance ?
							(guarantee.hazardousIndustryDistance| uppercase) : UNDERSCORE }}
						</div>
					</div>
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.industry.type</div>
						<div class="guarantee-details-block-value">{{ guarantee.typeOfIndustry ?
							(guarantee.typeOfIndustry | uppercase) : UNDERSCORE }}</div>
					</div>
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.emission.type</div>
						<div class="guarantee-details-block-value">{{ guarantee.typeOfEmissions ?
							(guarantee.typeOfEmissions | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.prevailing.wind</div>
						<div class="guarantee-details-block-value">
							{{ guarantee.gasCarriedWinds === 'true' ? ('guarantee.radio.yes' | translate) :
							guarantee.gasCarriedWinds === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE  }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid2">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.desert</div>
						<div class="guarantee-details-block-value">
							{{ (guarantee.inDesert === true ? 'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.area</div>
						<div class="guarantee-details-block-value">{{ guarantee.desertComment ?
							(guarantee.desertComment | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid2">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.coastal.marine</div>
						<div class="guarantee-details-block-value">{{ (guarantee.coastalMarineEnvironment === true ?
								'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.distance.less than 300m</div>
						<div class="guarantee-details-block-value">{{ (guarantee.lessThan300mfromCoast === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1" *ngIf="guarantee.applicationType === 'Magnelis-Other application' 
				|| guarantee.applicationType === 'Organic Coating' || guarantee.applicationType === 'Magnelis-Building';else solarType">
					<ng-container *ngIf="guarantee.applicationType === 'Organic Coating'">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.distance.3KM.seafront</div>
							<div class="guarantee-details-block-value">{{(guarantee.buildingEnvBLSpecifyDistance === true ?
								'guarantee.radio.yes':'guarantee.radio.no') | translate }}</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.distance.seafrontkm</div>
							<div class="guarantee-details-block-value">{{guarantee.buildingEnvBLPleaseSpecify ?
								(guarantee.buildingEnvBLPleaseSpecify | uppercase) : UNDERSCORE }}</div>
						</div>
					</ng-container>
					<ng-container *ngIf="guarantee.applicationType === 'Magnelis-Other application' 
					|| guarantee.applicationType === 'Magnelis-Building'">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.distance.seafrontkm</div>
							<div class="guarantee-details-block-value">{{guarantee.distanceToSea ?
								(guarantee.distanceToSea | uppercase) : UNDERSCORE }}</div>
						</div>
					</ng-container>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.without.direct.wetting</div>
						<div class="guarantee-details-block-value">{{ (guarantee.withoutWettingSeaWater === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.with.partial.momentary.wetting</div>
						<div class="guarantee-details-block-value">{{ (guarantee.partialWettingSeaWater === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<ng-template #solarType>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.between.300mand2km</div>
							<div class="guarantee-details-block-value">{{ (guarantee.between300m2kmfromCoast === true ?
								'guarantee.radio.yes':'guarantee.radio.no') | translate }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.between.2kmand10km</div>
							<div class="guarantee-details-block-value">{{ (guarantee.between2km10kmfromCoast === true ?
								'guarantee.radio.yes':'guarantee.radio.no') | translate }}
							</div>
						</div>
					</div>
				</ng-template>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.specific.environment</div>
						<div class="guarantee-details-block-value">{{ (guarantee.specificEnvironment === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.distance.lake</div>
						<div class="guarantee-details-block-value">{{ guarantee.distancetoLakeRiver ?
							(guarantee.distancetoLakeRiver | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
			</div>
			<div #atmosphericCorrosion>
				<ng-container *ngIf="guarantee.applicationType !== 'Organic Coating'">
					<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
						guarantee.atmospheric.corrosion</div>
					<ng-container *ngIf="guarantee.applicationType === 'Magnelis-Solar'; else otherBuildingType">
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.upper.structure</div>
								<div class="guarantee-details-block-value">{{ (guarantee.upperStructureGuarantee === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item" *ngIf="guarantee.upperStructureGuarantee === true">
								<div class="guarantee-details-block-label" translate>gurantee.duration.years</div>
								<div class="guarantee-details-block-value">{{ guarantee.guaranteeDurationRequested ?
									guarantee.guaranteeDurationRequested : UNDERSCORE }}</div>
							</div>
						</div>
						<ng-container *ngIf="guarantee.upperStructureGuarantee === true">
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.magnelis</div>
								<div class="guarantee-details-block-value">{{ guarantee.magnelisZM310 === true ? ('guarantee.magnelis.zm310' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.magnelisZM430 === true ? ('guarantee.magnelis.zm430' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.magnelisZM620 === true ? ('guarantee.magnelis.zm620' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value" *ngIf="user.hasServiceParameterEqualsTo('PGNTE','magnelissolar','Spain')">
									{{guarantee.isOtherCoatingMass === true ? ('guarantee.magnelis.other'| translate) : '' }}</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.magnelisZM310 === false 
									&& guarantee.magnelisZM430 === false && guarantee.magnelisZM620 === false
									&& (user.hasServiceParameterEqualsTo('PGNTE','magnelissolar','Spain') ? guarantee.isOtherCoatingMass : false) === false">{{ UNDERSCORE }}</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item" *ngIf="user.hasServiceParameterEqualsTo('PGNTE','magnelissolar','Spain')">
								<div class="guarantee-details-block-label" translate>gurantee.other.coating.mass</div>
								<div class="guarantee-details-block-value">{{guarantee.otherCoatingMass ? guarantee.otherCoatingMass : UNDERSCORE }}</div>
							</div>
						</div>
						</ng-container>
						<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
							guarantee.poles.soil
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.poles.magnelis</div>
								<div class="guarantee-details-block-value">{{ (guarantee.polesGuarantee === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item" *ngIf="guarantee.polesGuarantee === true">
								<div class="guarantee-details-block-label" translate>gurantee.duration.years</div>
								<div class="guarantee-details-block-value">{{ guarantee.poleGuaranteeDurationRequested ?
									guarantee.poleGuaranteeDurationRequested : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1" *ngIf="guarantee.polesGuarantee === true">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.magnelis</div>
								<div class="guarantee-details-block-value">{{ guarantee.polesMagnelisZM430 === true ? ('guarantee.magnelis.zm430' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.polesMagnelisZM620 === true ? ('guarantee.magnelis.zm620' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.polesMagnelisZM800 === 'Yes' ? ('guarantee.magnelis.zm800' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.polesMagnelisZM430 === false 
									&& guarantee.polesMagnelisZM620 === false && guarantee.polesMagnelisZM800 !== 'Yes'">{{ UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid2" *ngIf="guarantee.polesGuarantee === true">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.soil.analysis</div>
								<div class="guarantee-details-block-value">{{ (guarantee.soilAnalysis === true ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item" *ngIf="guarantee.soilAnalysis === true">
								<div class="guarantee-details-block-label" translate>guarantee.attachment</div>
								<ng-container *ngIf="getSoilAnalysisAttachments(guarantee).length > 0; else noattachment">
									<div class="guarantee-details-block-value" *ngFor="let attachment of getSoilAnalysisAttachments(guarantee)">
										<a target="_blank" rel="noopener"
																			   [href]="getAttachmentUrl(guarantee.id!, attachment) | copoSafeUrl"
										(click)="showAttachment($event, attachment)"
										class="attachment-container">
											<mat-icon svgIcon="table_document" class="setting-icon-16 left-pad"></mat-icon>
											{{ attachment.name }}
										</a>
									</div>
								</ng-container>
															<ng-template #noattachment><span>{{UNDERSCORE}}</span></ng-template>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
							guarantee.project.for.floating.solar
						</div>
						<div class="guarantee-details-block-info-grid2">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.floating.solar.magnelis</div>
								<div class="guarantee-details-block-value">{{ (guarantee.guaranteeForFloatingSolarMagnelis === 'Yes' ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item" *ngIf="guarantee.guaranteeForFloatingSolarMagnelis === 'Yes'">
								<div class="guarantee-details-block-label" translate>gurantee.duration.years</div>
								<div class="guarantee-details-block-value">{{ guarantee.guaranteeDurationRequestedForFoating ?
									guarantee.guaranteeDurationRequestedForFoating : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1" *ngIf="guarantee.guaranteeForFloatingSolarMagnelis === 'Yes'">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.magnelis</div>
								<div class="guarantee-details-block-value">{{ guarantee.floatingSolarMagnelisZM430 === 'Yes' ? ('guarantee.magnelis.zm430' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.floatingSolarMagnelisZM620 === 'Yes' ? ('guarantee.magnelis.zm620' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.floatingSolarMagnelisZM800 === 'Yes' ? ('guarantee.magnelis.zm800' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.floatingSolarMagnelisZM430 !== 'Yes' 
									&& guarantee.floatingSolarMagnelisZM620 !== 'Yes' && guarantee.floatingSolarMagnelisZM800 !== 'Yes'">{{ UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid2" *ngIf="guarantee.guaranteeForFloatingSolarMagnelis === 'Yes'">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.water.analysis</div>
								<div class="guarantee-details-block-value">{{ (guarantee.floatingSolarInstallationAnalysis === 'Yes' ?
									'guarantee.radio.yes':'guarantee.radio.no') | translate }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item" *ngIf="guarantee.floatingSolarInstallationAnalysis === 'Yes'">
								<div class="guarantee-details-block-label" translate>guarantee.attachment</div>
								<ng-container *ngIf="getWaterAnalysisAttachments(guarantee).length > 0; else noWaterAttachment">
									<div class="guarantee-details-block-value"
										*ngFor="let attachment of getWaterAnalysisAttachments(guarantee)">
										<a target="_blank" rel="noopener"
																			  [href]="getWaterAnalysisAttachmentUrl(guarantee.id!, attachment) | copoSafeUrl"
										(click)="showAttachment($event, attachment)"
										class="attachment-container">
											<mat-icon svgIcon="table_document" class="setting-icon-16 left-pad"></mat-icon>
											{{ attachment.name }}
										</a>
									</div>
								</ng-container>
															<ng-template #noWaterAttachment><span>{{UNDERSCORE}}</span></ng-template>
							</div>
						</div>
					</ng-container>
					<ng-template #otherBuildingType>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.magnelis</div>
								<div class="guarantee-details-block-value">{{ guarantee.magnelisZM310 === true ? ('guarantee.magnelis.zm310' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.magnelisZM430 === true ? ('guarantee.magnelis.zm430' |
									translate) : '' }}
								</div>
								<div class="guarantee-details-block-value">{{guarantee.suggestedCoatingMass === true ?
									('guarantee.suggested.coating.mass'
									| translate) : '' }}</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.magnelisZM310 === false 
								&& guarantee.magnelisZM430 === false && guarantee.suggestedCoatingMass === false">{{ UNDERSCORE }}</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>gurantee.duration.years</div>
							<div class="guarantee-details-block-value">{{guarantee.guaranteeDurationRequested ?
								guarantee.guaranteeDurationRequested : UNDERSCORE }}
							</div>
						</div>
					</ng-template>
				</ng-container>
			</div>
			<div *ngIf="guarantee.applicationType === 'Organic Coating'" #typesOfGuarantee>
				<div class="guarantee-details-block-info-grid1 guarantee-details-block-subtitle" translate>
					guarantee.types.of.guarantee</div>
				<div class="guarantee-details-block-info-grid2" *ngIf="guarantee.typeOfGuaGrOutdoor === true
						|| guarantee.typeofGuaGrIndoor === true">
					<div class="guarantee-details-block-info-item" *ngIf="guarantee.typeOfGuaGrOutdoor === true">
						<div class="guarantee-details-block-label" translate>guarantee.requested.type.outdoor.label</div>
						<div class="guarantee-details-block-value">
							{{ guarantee.outdoorGuaranteeDurationExpected
								? (( +guarantee.outdoorGuaranteeDurationExpected <= 1
										? 'guarantee.duration.year'
										: 'guarantee.duration.years'
									) | translate:{ value: guarantee.outdoorGuaranteeDurationExpected })
								: UNDERSCORE }}
						</div>
					</div>
					<div class="guarantee-details-block-info-item" *ngIf="guarantee.typeofGuaGrIndoor === true">
						<div class="guarantee-details-block-label" translate>guarantee.requested.type.indoor.label</div>
						<div class="guarantee-details-block-value">
							{{ guarantee.indoorGuaranteeDurationExpected
								? (( +guarantee.indoorGuaranteeDurationExpected <= 1
										? 'guarantee.duration.year'
										: 'guarantee.duration.years'
									) | translate:{ value: guarantee.indoorGuaranteeDurationExpected })
								: UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid2">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.open.building</div>
						<div class="guarantee-details-block-value">{{( guarantee.typeOfGUAOpenBuildingYes === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}</div>
					</div>
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.open.building.specify</div>
						<div class="guarantee-details-block-value">{{guarantee.typeOfGUAOpenBuildingYesSpecify ?
							(guarantee.typeOfGUAOpenBuildingYesSpecify | uppercase) : UNDERSCORE }}</div>
					</div>
				</div>
			</div>
			<div #organicCoatingRoofing>
				<ng-container *ngIf="guarantee.ocRoofing === true && (guarantee.roofingDeckingRoof === true
						|| guarantee.roofingSingleSkinRoof === true || guarantee.roofingDoubleSkinRoof === true)">
					<div class="guarantee-details-block-subtitle2" translate>guarantee.roofing</div>
					<ng-container *ngIf="guarantee.roofingDeckingRoof === true">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle3" translate>guarantee.roofing.decking.roof</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDRSubstrateThickness ?
									(guarantee.roofingDRSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDRDesiredCoating ?
									(guarantee.roofingDRDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDRDesiredBackCoating ?
									(guarantee.roofingDRDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDRMetallicCoatingWeight ?
									(guarantee.roofingDRMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDRColor ?
									(guarantee.roofingDRColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.surface</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDRSurface ?
									(guarantee.roofingDRSurface | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing.roofslope</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDRRoofslope ?
									(guarantee.roofingDRRoofslope | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="guarantee.roofingSingleSkinRoof === true">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle3" translate>guarantee.single.skin.roof</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSSRSubstrateThickness ?
									(guarantee.roofingSSRSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSSRDesiredCoating ?
									(guarantee.roofingSSRDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSSRDesiredBackCoating ?
									(guarantee.roofingSSRDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSSRMetallicCoatingWeight ?
									(guarantee.roofingSSRMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSSRColor ?
									(guarantee.roofingSSRColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.surface</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSSRSurface ?
									(guarantee.roofingSSRSurface | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing.roofslope</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSSRRoofslope ?
									(guarantee.roofingSSRRoofslope | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="guarantee.roofingDoubleSkinRoof === true">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle3" translate>guarantee.double.skin.roof</div>
							<div class="guarantee-details-block-subtitle4" translate>guarantee.roofing-cladding.external.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsresSubstrateThickness ?
									(guarantee.roofingDsresSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsresDesiredCoating ?
									(guarantee.roofingDsresDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsresDesiredBackCoating ?
									(guarantee.roofingDsresDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsresMetallicCoatingWeight ?
									(guarantee.roofingDsresMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsrEsColor ?
									(guarantee.roofingDsrEsColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle4" translate>guarantee.roofing-cladding.internal.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsrisSubstrateThickness ?
									(guarantee.roofingDsrisSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsrisDesiredCoating ?
									(guarantee.roofingDsrisDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsrisDesiredBackCoating ?
									(guarantee.roofingDsrisDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsrisMetallicCoatingWeight ?
									(guarantee.roofingDsrisMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDsrIsColor ?
									(guarantee.roofingDsrIsColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.surface</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDSRSurface ?
									(guarantee.roofingDSRSurface | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing.roofslope</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingDSRRoofslope ?
									(guarantee.roofingDSRRoofslope | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>	
				</ng-container>				
			</div>
			<div #ocRoofingSandwichPanel>
				<ng-container *ngIf="guarantee.ocRoofing === true">
					<div class="guarantee-details-block-subtitle2" 
					*ngIf="guarantee.roofingDeckingRoof === false && guarantee.roofingSingleSkinRoof === false
						&& guarantee.roofingDoubleSkinRoof === false" translate>guarantee.roofing</div>
					<ng-container *ngIf="guarantee.roofingSandwichPanelsBuiltUpSys === true">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle3" translate>guarantee.sandwich.panel</div>
							<div class="guarantee-details-block-subtitle4" translate>guarantee.roofing-cladding.external.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPESSubstrateThickness ?
									(guarantee.roofingSPESSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPESDesiredCoating ?
									(guarantee.roofingSPESDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPESDesiredBackCoating ?
									(guarantee.roofingSPESDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPESMetallicCoatingWeight ?
									(guarantee.roofingSPESMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPESColor ?
									(guarantee.roofingSPESColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle4" translate>guarantee.roofing-cladding.internal.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPISSubstrateThickness ?
									(guarantee.roofingSPISSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPISDesiredCoating ?
									(guarantee.roofingSPISDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPISDesiredBackCoating ?
									(guarantee.roofingSPISDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPISMetallicCoatingWeight ?
									(guarantee.roofingSPISMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPISColor ?
									(guarantee.roofingSPISColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.surface</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPSurface ?
									(guarantee.roofingSPSurface | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing.roofslope</div>
								<div class="guarantee-details-block-value">{{ guarantee.roofingSPRoofslope ?
									(guarantee.roofingSPRoofslope | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.insulation</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.roofingSPInsulationPU === true ? ( 'guarantee.pu.insulation' | translate | uppercase) :
									'' }}
								</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.roofingSPInsulationPIR === true ? ('guarantee.pir.insulation'| translate | uppercase) :
									'' }}
								</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.roofingSPInsulationMineralWool === true ? ( 'guarantee.mineral.wool.insulation' |
									translate | uppercase) : '' }}
								</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.roofingSPInsulationPU === false 
								&& guarantee.roofingSPInsulationPIR === false && guarantee.roofingSPInsulationMineralWool === false">{{ UNDERSCORE
									}}
								</div>
							</div>
						</div>
					</ng-container>
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.overlapping</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.roofingOverlapping === 'true' ? ('guarantee.radio.yes' | translate)
								: guarantee.roofingOverlapping === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.perforation</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.roofingPerforationYes === 'true' ? ('guarantee.radio.yes' | translate) :
								guarantee.roofingPerforationYes === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item" *ngIf="guarantee.roofingPerforationYes === 'true'">
							<div class="guarantee-details-block-label" translate>guarantee.specify.perforation.scheme</div>
							<div class="guarantee-details-block-value">{{ guarantee.roofingPerforationYesSpecify ?
								(guarantee.roofingPerforationYesSpecify | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.pv.solar.roof</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.roofingPVSolarRoof === 'true' ? ('guarantee.radio.yes' | translate) :
								guarantee.roofingPVSolarRoof === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE  }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.anti-condensation.felt</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.roofingAntiCondensationFelt === 'true' ? ('guarantee.radio.yes' | translate) 
								: guarantee.roofingAntiCondensationFelt === 'false' ? ('guarantee.radio.no' | translate) 
								: UNDERSCORE }}
							</div>
						</div>
					</div>
				</ng-container>
			</div>
			<div #ocCladding>
				<ng-container *ngIf="guarantee.clad === true && (guarantee.cladSingleSkin === true || guarantee.cladDoubleSkin === true)">
					<div class="guarantee-details-block-subtitle2" translate>guarantee.cladding</div>
					<ng-container *ngIf="guarantee.cladSingleSkin === true">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle3" translate>guarantee.cladding.single.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSSSubstrateThickness ?
									(guarantee.cladSSSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSSDesiredCoating ?
									(guarantee.cladSSDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSSDesiredBackCoating ?
									(guarantee.cladSSDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSSMetallicCoatingWeight ?
									(guarantee.cladSSMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSSColor ?
									(guarantee.cladSSColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.surface</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSSSurface ?
									(guarantee.cladSSSurface | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="guarantee.cladDoubleSkin === true">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle3" translate>guarantee.cladding.double.skin</div>
							<div class="guarantee-details-block-subtitle4" translate>guarantee.roofing-cladding.external.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSESSubstrateThickness ?
									(guarantee.cladDSESSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSESDesiredCoating ?
									(guarantee.cladDSESDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSESDesiredBackCoating ?
									(guarantee.cladDSESDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSESMetallicCoatingWeight ?
									(guarantee.cladDSESMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSESColor ?
									(guarantee.cladDSESColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.surface</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSESSurface ?
									(guarantee.cladDSESSurface | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle4" translate>guarantee.roofing-cladding.internal.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSISSubstrateThickness ?
									(guarantee.cladDSISSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSISDesiredCoating ?
									(guarantee.cladDSISDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSISDesiredBackCoating ?
									(guarantee.cladDSISDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSISMetallicCoatingWeight ?
									(guarantee.cladDSISMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSISColor ?
									(guarantee.cladDSISColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.surface</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladDSISSurface ?
									(guarantee.cladDSISSurface | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>					
				</ng-container>
			</div>
			<div #ocCladdingSandwichPanel>
				<ng-container *ngIf="guarantee.clad === true">
					<div class="guarantee-details-block-subtitle2" 
					*ngIf="guarantee.cladSingleSkin === false && guarantee.cladDoubleSkin === false" translate>guarantee.cladding</div>
					<ng-container *ngIf="guarantee.cladSandwichPanelsBuiltUpSys === true">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle3" translate>guarantee.sandwich.panel</div>
							<div class="guarantee-details-block-subtitle4" translate>guarantee.roofing-cladding.external.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPESSubstrateThickness ?
									(guarantee.cladSPESSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPESDesiredCoating ?
									(guarantee.cladSPESDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPESDesiredBackCoating ?
									(guarantee.cladSPESDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPESMetallicCoatingWeight ?
									(guarantee.cladSPESMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPESColor ?
									(guarantee.cladSPESColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-subtitle4" translate>guarantee.roofing-cladding.internal.skin</div>
						</div>
						<div class="guarantee-details-block-info-grid">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.substrate.thickness
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPISSubstrateThickness ?
									(guarantee.cladSPISSubstrateThickness | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.coating</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPISDesiredCoating ?
									(guarantee.cladSPISDesiredCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.desired.back.coat</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPISDesiredBackCoating ?
									(guarantee.cladSPISDesiredBackCoating | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.metallic.coating.weight
								</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPISMetallicCoatingWeight ?
									(guarantee.cladSPISMetallicCoatingWeight | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.color</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPISColor ?
									(guarantee.cladSPISColor | uppercase) : UNDERSCORE }}
								</div>
							</div>
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.surface</div>
								<div class="guarantee-details-block-value">{{ guarantee.cladSPSurface ?
									(guarantee.cladSPSurface | uppercase) : UNDERSCORE }}
								</div>
							</div>
						</div>
						<div class="guarantee-details-block-info-grid1">
							<div class="guarantee-details-block-info-item">
								<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.insulation</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.cladSPInsulationPU === true ? ( 'guarantee.pu.insulation' | translate | uppercase) : ''
									}}
								</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.cladSPInsulationPIR === true ? ('guarantee.pir.insulation'| translate | uppercase) : ''
									}}
								</div>
								<div class="guarantee-details-block-value">
									{{ guarantee.cladSPInsulationMineralWool === true ? ( 'guarantee.mineral.wool.insulation' |
									translate | uppercase) : '' }}
								</div>
								<div class="guarantee-details-block-value" *ngIf="guarantee.cladSPInsulationPU === false 
								&& guarantee.cladSPInsulationPIR === false && guarantee.cladSPInsulationMineralWool === false">{{ UNDERSCORE }}
								</div>
							</div>
						</div>
					</ng-container>
					<div class="guarantee-details-block-info-grid1">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.overlapping</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.cladOverlapping === 'true' ? ('guarantee.radio.yes' | translate)
								: guarantee.cladOverlapping === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.roofing-cladding.perforation</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.cladPerforationYes === 'true' ? ('guarantee.radio.yes' | translate)
								: guarantee.cladPerforationYes === 'false' ? ('guarantee.radio.no' | translate) : UNDERSCORE }}
							</div>
						</div>
						<div class="guarantee-details-block-info-item" *ngIf="guarantee.cladPerforationYes === 'true'">
							<div class="guarantee-details-block-label" translate>guarantee.specify.perforation.scheme</div>
							<div class="guarantee-details-block-value">{{ guarantee.cladPerforationYesSpecify ?
								(guarantee.cladPerforationYesSpecify | uppercase) : UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="guarantee-details-block-info-grid2">
						<div class="guarantee-details-block-info-item">
							<div class="guarantee-details-block-label" translate>guarantee.direction.of.cladding.installation</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.cladDirectionOfInstallation === true ? ( 'guarantee.installation.direction.horizontal' |
								translate | uppercase) : '' }}
							</div>
							<div class="guarantee-details-block-value">
								{{ guarantee.cladVertical === true ? ('guarantee.installation.direction.vertical'| translate |
								uppercase) : '' }}
							</div>
							<div class="guarantee-details-block-value" *ngIf="guarantee.cladDirectionOfInstallation === false 
							&& guarantee.cladVertical === false">{{ UNDERSCORE }}
							</div>
						</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="guarantee.applicationType === 'Organic Coating'" #ocRoofingCladdingOthers>
				<div class="guarantee-details-block-info-grid2">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label">{{ 'guarantee.Others' | translate | uppercase }}</div>
						<div class="guarantee-details-block-value">{{(guarantee.othersAntiCondensationFelt === true ?
							'guarantee.radio.yes':'guarantee.radio.no') | translate }}
						</div>
					</div>
					<div class="guarantee-details-block-info-item" *ngIf="guarantee.othersAntiCondensationFelt === true">
						<div class="guarantee-details-block-label" translate>guarantee.others.please.specify</div>
						<div class="guarantee-details-block-value">{{ guarantee.othersSpecifyAntiCondensationFelt ?
							(guarantee.othersSpecifyAntiCondensationFelt | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.other.materials.used</div>
						<div class="guarantee-details-block-value">
							{{ guarantee.omuRoofCladmadeWithProduct === true ? ( 'guarantee.roofing-cladding.made.with.product' |
							translate | uppercase) : '' }}
						</div>
						<div class="guarantee-details-block-value">
							{{ guarantee.omuUseofMaterialCementBreezeblocks === true ? ('guarantee.use.of.other.materials'|
							translate | uppercase) : '' }}
						</div>
						<div class="guarantee-details-block-value" *ngIf="guarantee.omuRoofCladmadeWithProduct === false 
								&& guarantee.omuUseofMaterialCementBreezeblocks === false">{{ UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid1">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.roofing.specify.material.type</div>
						<div class="guarantee-details-block-value">{{ guarantee.omuInRoofing ?
							(guarantee.omuInRoofing | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="guarantee-details-block-info-grid2">
					<div class="guarantee-details-block-info-item">
						<div class="guarantee-details-block-label" translate>guarantee.cladding.specify.material.type</div>
						<div class="guarantee-details-block-value">{{ guarantee.omuInCladding ?
							(guarantee.omuInCladding | uppercase) : UNDERSCORE }}
						</div>
					</div>
					<div class="guarantee-details-block-info-item" *ngIf="legacyAttachmentDisplay">
						<div class="guarantee-details-block-label" translate>guarantee.attachment</div>
						<ng-container *ngIf="getAttachments(guarantee).length > 0; else noOrganicCoatingAttachment">
							<div class="guarantee-details-block-value" *ngFor="let attachment of getAttachments(guarantee)">
								<a target="_blank" rel="noopener"
									[href]="getAttachmentUrl(guarantee.id!, attachment) | copoSafeUrl"
									(click)="showAttachment($event, attachment)"
									class="attachment-container">
									<mat-icon svgIcon="table_document" class="setting-icon-16 left-pad"></mat-icon>
									{{ attachment.name }}
								</a>
							</div>
						</ng-container>
						<ng-template #noOrganicCoatingAttachment><span>{{ UNDERSCORE }}</span></ng-template>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div #combinedPartsAndOthers>
		<div class="guarantee-other-material-block" #otherMaterials>
			<div class="guarantee-other-material-block-item" *ngIf="guarantee.applicationType !== 'Organic Coating'">
				<div class="guarantee-other-material-block-identity guarantee-other-material-block-title" translate>
					guarantee.other.materials
				</div>
				<div class="guarantee-other-material-block-info">
					<div class="guarantee-other-material-block-info-item">
						<div class="guarantee-other-material-block-label" translate>guarantee.magnelis</div>
						<div class="guarantee-other-material-block-value">{{guarantee.entireMagnelisStructure === true ? ('guarantee.structure' |
							translate) : ''}}</div>
						<div class="guarantee-other-material-block-value">{{guarantee.stainlessSteelParts === true ? ('guarantee.steel.parts' |
							translate) : ''}}</div>
						<div class="guarantee-other-material-block-value">{{guarantee.aluminiumParts === true ? ('guaranatee.aluminium.parts' |
							translate) : ''}}</div>
						<div class="guarantee-other-material-block-value">{{guarantee.foundationsConcrete === true ?
							('guarantee.concrete.foundations' | translate) : '' }}</div>
						<div class="guarantee-other-material-block-value" *ngIf="guarantee.entireMagnelisStructure === false 
						&& guarantee.stainlessSteelParts === false 
						&& guarantee.aluminiumParts === false 
						&& guarantee.foundationsConcrete === false ">{{ UNDERSCORE }}</div>
					</div>
				</div>
				<div class="guarantee-other-material-block-identity guarantee-other-material-block-subtitle" translate>
					guarantee.fastners
				</div>
				<div class="guarantee-other-material-block-info">
					<div class="guarantee-other-material-block-info-item">
						<div class="guarantee-other-material-block-label" translate>guarantee.magnelis</div>
						<div class="guarantee-other-material-block-value">{{guarantee.stainlessSteel === true ? ('guarantee.stainless.steel' |
							translate) : ''}}</div>
						<div class="guarantee-other-material-block-value">{{guarantee.zincCoated === true ? ('guarantee.zinc' |
							translate) : ''}}</div>
						<div class="guarantee-other-material-block-value">{{guarantee.otherCoatingsSteel === true ? ('guarantee.other.coatings' |
							translate) : '' }}</div>
						<div class="guarantee-other-material-block-value">{{guarantee.aluminium === true ? ('guarantee.aluminium' |
							translate) : ''}}</div>
						<div class="guarantee-other-material-block-value" *ngIf="guarantee.stainlessSteel === false 
						&& guarantee.zincCoated === false 
						&& guarantee.otherCoatingsSteel === false 
						&& guarantee.aluminium === false ">{{ UNDERSCORE }}</div>
					</div>
				</div>
				<div class="guarantee-other-material-block-info">
					<div class="guarantee-other-material-block-info-item">
						<div class="guarantee-other-material-block-label" translate>guarantee.contact.parts</div>
						<div class="guarantee-other-material-block-value">{{ guarantee.magnelisContactPartsCoating ?
							(guarantee.magnelisContactPartsCoating | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="guarantee-other-material-block-info">
					<div class="guarantee-other-material-block-info-item">
						<div class="guarantee-other-material-block-label" translate>guarantee.contact.orther.parts</div>
						<div class="guarantee-other-material-block-value">{{ guarantee.magnelisContactPartsOtherMaterial ?
							(guarantee.magnelisContactPartsOtherMaterial | uppercase) : UNDERSCORE }}
						</div>
					</div>
				</div>
			</div>
			<div class="guarantee-other-material-block-item" *ngIf="showAdditionalDocuments">
				<div class="guarantee-other-material-block-identity guarantee-other-material-block-title" translate>
					guarantee.additional.documents
				</div>
				<div class="guarantee-other-material-block-info">
					<div class="guarantee-other-material-block-info-item">
						<ng-container *ngIf="getOtherAttachments(guarantee).length > 0; else noAdditionalDocuments">
							<div class="guarantee-other-material-block-value" *ngFor="let attachment of getOtherAttachments(guarantee)">
								<a target="_blank" rel="noopener"
								[href]="getAttachmentUrl(guarantee.id!, attachment) | copoSafeUrl"
								(click)="showAttachment($event, attachment)"
								class="attachment-container">
									<mat-icon [svgIcon]="isWebformAttachment(attachment) ? 'attachment_webform' : 'table_document'"
										class="setting-icon-16 left-pad"></mat-icon>
									{{ attachment.name }}
								</a>
							</div>
						</ng-container>
						<ng-template #noAdditionalDocuments><span>{{UNDERSCORE}}</span></ng-template>
					</div>
				</div>
			</div>
		</div>
		<div class="guarantee-parts-block" #guaranteeParts>
			<div class="guarantee-parts-block-item" *ngIf="guarantee.applicationType !== 'Organic Coating'">
				<div class="guarantee-parts-block-identity guarantee-parts-block-title" translate>
					guarantee.parts.magnelis
				</div>
				<ng-container *ngIf="guarantee.parts.length > 0 ; else noparts">
					<div class="guarantee-parts-block-info" *ngFor="let part of guarantee.parts">
						<div class="guarantee-parts-block-info-item">
							<div class="guarantee-parts-block-label" translate>guarantee.designation</div>
							<div class="guarantee-parts-block-value">{{	part.name ? part.name : UNDERSCORE }}</div>
						</div>
						<div class="guarantee-parts-block-info-item">
							<div class="guarantee-parts-block-label" translate>guarantee.part.magnelis</div>
							<div class="guarantee-parts-block-value">{{ part.magnelisCoatingMass ? part.magnelisCoatingMass : UNDERSCORE }}</div>
						</div>
						<div class="guarantee-parts-block-info-item">
							<div class="guarantee-parts-block-label" translate>guarantee.sheet.thickness</div>
							<div class="guarantee-parts-block-value">{{ part.sheetThickness ? part.sheetThickness : UNDERSCORE }}</div>
						</div>
						<div class="guarantee-parts-block-info-item" *ngIf="guarantee.applicationType === 'Magnelis-Solar'">
							<div class="guarantee-parts-block-label" translate>guarantee.part.corrosion</div>
							<div class="guarantee-parts-block-value">{{ part.corrosion ? (('corrosion.' + part.corrosion) | translate ) : UNDERSCORE }}</div>
						</div>
						<div class="guarantee-parts-block-info-item" *ngIf="guarantee.applicationType === 'Magnelis-Other application' 
							|| guarantee.applicationType === 'Magnelis-Building'">
								<div class="guarantee-parts-block-label" translate>guarantee.epassivation.type</div>
								<div class="guarantee-parts-block-value">
									{{ part.epassivationEasyfilm ? (('epassivefilm.' + part.epassivationEasyfilm) |
									translate ) : UNDERSCORE }}
								</div>
							</div>
						<div class="guarantee-parts-block-info-item">
							<div class="guarantee-parts-block-label" translate>guarantee.fabrication</div>
							<div class="guarantee-parts-block-value">{{ part.fabricationProcess ?
								(('fabrication.process.' + part.fabricationProcess) | translate ) : UNDERSCORE }}
							</div>
						</div>
					</div>
				</ng-container>
				<ng-template #noparts><span class="parts-align" translate>guarantee.no.parts.magnelis</span></ng-template>
			</div>
			<div class="guarantee-other-material-block-item">
				<div class="guarantee-other-material-block-identity guarantee-other-material-block-title" translate>
					guarantee.additional.comments
				</div>
				<div class="guarantee-other-material-block-info">
					<div class="guarantee-other-material-block-info-item guarantee-other-material-block-value">{{ guarantee.customerAdditionalInformation ?
						(guarantee.customerAdditionalInformation | uppercase) : UNDERSCORE }}
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>